import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { StyleTemplateForm } from '@/forms/StyleTemplateForm';
import { createStyleTemplate } from '@/api/services/style-templates/createStyleTemplate';
import type { CreateStyleTemplateRequest } from 'schemas';
import { createStyleTemplatePageMessages } from './createStyleTemplatePage.messages';
import { ROUTES } from '@/routes';
import { DashboardPageContainer } from '@/components/layout/DashboardPageContainer';
import { ApiError } from '@/api/ApiError';
import { UNKNOWN_ERROR_API_ERROR } from '@/api/helpers/unknownError';

export function CreateStyleTemplatePage() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (formData: CreateStyleTemplateRequest) => {
    try {
      setIsSubmitting(true);

      const result = await createStyleTemplate(formData);
      if (result) {
        // Navigate back to style templates page
        navigate(ROUTES.DASHBOARD_STYLE_TEMPLATES);
      }
    } catch (err) {
      const apiError = err instanceof ApiError ? err : UNKNOWN_ERROR_API_ERROR;
      toast.error(apiError.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(ROUTES.DASHBOARD_STYLE_TEMPLATES);
  };

  return (
    <DashboardPageContainer
      headline={createStyleTemplatePageMessages.pageTitle}
      subheading={createStyleTemplatePageMessages.pageDescription}
    >
      <div aria-label={createStyleTemplatePageMessages.formContainerAriaLabel}>
        <StyleTemplateForm
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          onCancel={handleCancel}
        />
      </div>
    </DashboardPageContainer>
  );
}
